import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll, wsFindBy } from 'services/WService';
import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';

const useStyles = makeStyles((theme) => ({
  ...styles,
  selectFormControl: {
    textAlign: 'left'
  }
}));

export default function ModalVehicle(props) {
  const classes = useStyles();

  const vehicle = props.model;

  const [businessPartners, setBusinessPartners] = useState([]);
  const [zones, setZones] = useState([]);
  const [distributionStaffManagers, setDistributionStaffManagers] = useState([]);
  const [distributionStaffManagerInventorys, setDistributionStaffManagerInventorys] = useState([]);

  async function listBusinessPartners() {
    let response = await wsGetAll('base/business-partner?CardType=S&QryGroup3=Y');
    if (response.success) setBusinessPartners(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listDistributionStaffManagers(zoneId) {
    let response = await wsFindBy('prog/distribution-staff', {
      base_zone_id: zoneId,
      base_employee_positon_id: 2
    });
    if (response.success) {
      setDistributionStaffManagers(response.data);
    }
  }

  async function listDistributionStaffManagerInvetorys(zoneId) {
    let response = await wsFindBy('prog/distribution-staff', {
      base_zone_id: zoneId,
      base_employee_positon_id: 1
    });
    if (response.success) setDistributionStaffManagerInventorys(response.data);
  }

  useEffect(() => {
    listBusinessPartners();
    listZones();
    if (vehicle.id) {
      listDistributionStaffManagers(vehicle.base_zone_id);
      listDistributionStaffManagerInvetorys(vehicle.base_zone_id);
    }
  }, [vehicle]);

  return (
    <Modal
      title="Vehicle"
      model={vehicle}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="prog/vehicle"
    >
      <TextField
        label="Código"
        fullWidth
        name="code"
        margin="normal"
        defaultValue={vehicle.code || ''}
        required
      />
      <TextField
        label="Nombre"
        fullWidth
        name="name"
        margin="normal"
        defaultValue={vehicle.name || ''}
        required
      />
      <TextField
        label="Año"
        fullWidth
        name="year"
        margin="normal"
        defaultValue={vehicle.year || ''}
        required
      />
      <TextField
        label="Color"
        fullWidth
        name="color"
        margin="normal"
        defaultValue={vehicle.color || ''}
        required
      />
      <TextField
        label="Marca"
        fullWidth
        name="brand"
        margin="normal"
        defaultValue={vehicle.brand || ''}
        required
      />
      <TextField
        label="Modelo"
        fullWidth
        name="model"
        margin="normal"
        defaultValue={vehicle.model || ''}
        required
      />
      <TextField
        label="Peso"
        type="number"
        fullWidth
        name="weight"
        margin="normal"
        defaultValue={vehicle.weight || ''}
        required
      />
      <TextField
        label="Serie"
        fullWidth
        name="serial"
        margin="normal"
        defaultValue={vehicle.serial || ''}
        required
      />
      <TextField
        label="Tarjeta unica de circulacion"
        fullWidth
        name="card_circulation"
        margin="normal"
        defaultValue={vehicle.card_circulation || ''}
      />
      <FormControl
        fullWidth
        margin="normal"
        size="small"
        className={classes.selectFormControl}
        required
      >
        <InputLabel>Socio de Negocio</InputLabel>
        <Select
          defaultValue={vehicle.base_business_partner_id || ''}
          inputProps={{
            name: 'base_business_partner_id'
          }}
        >
          {businessPartners.map((item, i) => {
            return (
              <MenuItem key={i} value={item.id}>
                {item.CardName}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl
        fullWidth
        margin="normal"
        size="small"
        className={classes.selectFormControl}
        required
      >
        <InputLabel>Zona</InputLabel>
        <Select
          defaultValue={vehicle.base_zone_id || ''}
          inputProps={{
            name: 'base_zone_id'
          }}
        >
          {zones.map((item, i) => {
            return (
              <MenuItem
                key={i}
                value={item.id}
                onClick={() => {
                  listDistributionStaffManagers(item.id);
                  listDistributionStaffManagerInvetorys(item.id);
                }}
              >
                {item.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl
        fullWidth
        margin="normal"
        size="small"
        className={classes.selectFormControl}
        required
      >
        <InputLabel>Jefe reparto</InputLabel>
        <Select
          defaultValue={vehicle.prog_distribution_staff_id_manager || ''}
          inputProps={{
            name: 'prog_distribution_staff_id_manager'
          }}
        >
          {distributionStaffManagers.map((item, i) => {
            return (
              <MenuItem key={i} value={item.id}>
                {item.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl
        fullWidth
        margin="normal"
        size="small"
        className={classes.selectFormControl}
        required
      >
        <InputLabel>Encargado Mercadería</InputLabel>
        <Select
          defaultValue={vehicle.prog_distribution_staff_id_inventory_manager || ''}
          inputProps={{
            name: 'prog_distribution_staff_id_inventory_manager'
          }}
        >
          {distributionStaffManagerInventorys.map((item, i) => {
            return (
              <MenuItem key={i} value={item.id}>
                {item.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Modal>
  );
}
